import { useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import api from "../api";
import { UserContext } from "../context/UserContext";
import "./home.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { setUser } = useContext(UserContext);
  const nav = useNavigate();
  const location = useLocation();
  const showPwReset = location.search.includes("pwreset=1");

  const handleLogin = async () => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      if (data.token) {
        localStorage.setItem("token", data.token);
        console.log("JWT Token gespeichert:", data.token);
      }
      nav("/dashboard");
    } catch (e) {
      alert(e.response?.data?.error || "Login fehlgeschlagen");
    }
  };

  return (
    <div className="home-page" style={{width:'100vw',margin:0,padding:0}}>
  <section style={{width:'100vw', margin:0, padding:0, position:'relative', left:'-120px'}}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Login</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>
          Melde dich mit deinem Account an,<br/>
          um alle Funktionen des AP-Network zu nutzen.
        </p>
        {showPwReset && (
          <div style={{marginTop:16, color:'#1976d2', fontWeight:500, fontSize:16, background:'#e3f2fd', borderRadius:8, padding:'10px 18px'}}>
            Dein Passwort wurde erfolgreich geändert.<br/>Bitte logge dich mit dem neuen Passwort erneut ein.
          </div>
        )}
      </section>

  <section style={{width:'100vw',margin:0,padding:0}}>
        <form className="highlight-card" style={{gap:18, padding:32}} onSubmit={e=>{e.preventDefault(); handleLogin();}}>
          <h2 className="highlight-title" style={{marginBottom:8}}>Login</h2>
          <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem"}} placeholder="E-Mail" value={email} onChange={e=>setEmail(e.target.value)} />
          <div style={{position:'relative', height:'48px'}}>
            <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem", width:'100%'}} type={showPassword ? "text" : "password"} placeholder="Passwort" value={password} onChange={e=>setPassword(e.target.value)} />
            <button
              type="button"
              aria-label={showPassword ? "Passwort verbergen" : "Passwort anzeigen"}
              onClick={()=>setShowPassword(v=>!v)}
              style={{
                position:'absolute',
                right:12,
                top:'50%',
                transform:'translateY(-50%)',
                background:'none',
                border:0,
                cursor:'pointer',
                color:'#32CD89',
                fontSize:'1.3em',
                padding:'0 4px',
                lineHeight:1
              }}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
          <div style={{marginTop:8, textAlign:'right'}}>
            <Link to="/forgot-password" style={{color:'#32CD89', fontSize:'0.95em', fontWeight:500, textDecoration:'underline'}}>Passwort vergessen?</Link>
          </div>

          <button type="submit" className="hero-btn-primary" style={{marginTop:8}}>
            Einloggen
          </button>
          <div style={{fontSize:12, opacity:.8, marginTop:8}}>
            Neu? <Link to="/register" style={{color:'#32CD89', fontWeight:700}}>Zur Warteliste</Link>
          </div>
        </form>
      </section>

      <section className="cta-section">
  <div style={{width:'100%',margin:0,padding:0}}>
          <h2 className="cta-title">Noch kein Account?</h2>
          <p className="cta-desc">Registriere dich jetzt und werde Teil der Community.</p>
          <Link to="/register" className="cta-btn">Jetzt registrieren</Link>
        </div>
      </section>
    </div>
  );
}
